import React, { Component } from 'react';
import { Button, Form, Input, Modal, Spin } from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';

class AddNewDomainToBlacklistForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false
    };
  }

  handleRegister = (event) => {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let requestParams = [];
        let splitValue = values.domain.split(/\n/g);
        _.forEach(splitValue, (v) => {
          if (!_.isEmpty(v)) {
            requestParams.push({
              domain: v
            });
          }
        });

        this.props.onCreate(requestParams, this.props.form);
      }
    });
  };

  onCancel = () => {
    const form = this.props.form;
    form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { loaderIsVisible } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        title='ADD NEW DOMAIN TO BLACKLIST'
        visible={this.props.isVisible}
        onCancel={this.onCancel}
        keyboard={false}
        maskClosable={false}
        footer={[
          <Button key='back' loading={loaderIsVisible} onClick={this.onCancel}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loaderIsVisible}
            onClick={this.handleRegister}
          >
            Save
          </Button>
        ]}
      >
        <Spin size='large' spinning={loaderIsVisible}>
          <Form layout='vertical' prefixCls='add_new_user_'>
            <Form.Item label='Enter only one domain name'>
              {getFieldDecorator('domain', {
                rules: [
                  {
                    required: true,
                    message: 'This field cannot be empty.'
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

AddNewDomainToBlacklistForm.propTypes = {
  isVisible: PropTypes.bool,
  loaderIsVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func
};

export default Form.create({ name: 'AddNewDomainToBlacklistForm' })(
  AddNewDomainToBlacklistForm
);
